import { useEffect, useRef } from 'react';
import ExistingComment from '../ExistingComment/ExistingComment';
import { ICommentsAndObservations } from '../../../../types/global';
import './CommentsList.scss';

const CommentsList = ({ comments }: ICommentsListProps) => {
  const refListComment = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (refListComment.current) {
      refListComment.current.scrollTop = refListComment.current.scrollHeight;
    }
  }, [comments]);

  return (
    <div className="commentsList" ref={refListComment}>
      {comments?.map((comment, index) => {
        return <ExistingComment key={`comment-${comment?.id}-index-${index}`} comment={comment} index={index} />;
      })}
    </div>
  );
};

export default CommentsList;

interface ICommentsListProps {
  comments: ICommentsAndObservations[];
}
